import React, { useEffect, useState } from "react";
import moment from "moment";

const Timer = (props) => {
  const {
    hours: Hours,
    minutes: Minutes,
    seconds: Seconds,
    onComplete,
  } = props;

  const [timeProps, setTimeProps] = useState({
    durationInSeconds:
      (Hours || 0) * 60 * 60 + (Minutes || 0) * 60 + (Seconds || 0),
    timeoutRef: null,
  });

  useEffect(() => {
    const timeoutRef = setTimeout(() => {
      const { durationInSeconds } = timeProps;
      const remainingDuration = durationInSeconds - 1;

      setTimeProps(() => ({
        durationInSeconds: remainingDuration,
      }));

      if (remainingDuration <= 0) {
        onComplete && onComplete();
        clearTimeout(timeoutRef);
      }
    }, 1000);

    return () => {
      if (timeProps.timeoutRef) {
        clearTimeout(timeProps.timeoutRef);
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeProps]);

  const { durationInSeconds } = timeProps;

  if (!durationInSeconds) return null;

  const duration = moment.duration(durationInSeconds, "seconds");
  const hours = duration.hours() ? `${toText(duration.hours())}:` : "";
  const minutes = duration.minutes() ? `${toText(duration.minutes())}:` : "00:";
  const seconds = duration.seconds() ? `${toText(duration.seconds())}` : "00";

  const result = hours + minutes + seconds;

  return (
    <span className={props.className} style={props.style}>{` ${result}`}</span>
  );
};

const toText = (duration) => {
  if (duration < 10) return `0${duration}`;
  else return `${duration}`;
};

export default Timer;
